module.exports = __webpack_public_path__ + "static/media/3.71f6aa1a.svg";